export default "__VITE_ASSET__68166545__"